// extracted by mini-css-extract-plugin
module.exports = {"section":"TabInformation_section__pFiMT","specification":"TabInformation_specification__numte","description":"TabInformation_description___8BSd"};